import hookUIStore from './hookUIStore.js';
import hookDataStore from './hookDataStore.js';

export default {
  modules: {
    ui: hookUIStore,
    data: hookDataStore,
  },
};
